import { useSelector } from 'react-redux';
import { selectApplication } from '../store/selectors/applicationSelectors';

export const useMetalStreamData = () => {
  const Application = useSelector(selectApplication);
  const { MetalStream } = Application;

  if (!MetalStream) {
    return {};
  }

  return { MetalStreamData: MetalStream };
};
